import Button from "antd/lib/button";
import Tooltip from "antd/lib/tooltip";

export const SendRequestsBtnDisabledReasons: {
  NO_VALID_MATERIAL: string;
} = {
  NO_VALID_MATERIAL: "No material available to send request"
};

function Footer({
  data,
  onCancel,
  onSend,
  submitting,
  sendRequestsBtnProps,
  sendRequestsBtnDisabledReason,
  onExcludedClick
}: {
  data: {
    selectedCount: number;
    excludedCount: number;
    emailsToBeSentCount: number;
  };
  onCancel: () => void;
  onSend: () => void;
  submitting: boolean;
  sendRequestsBtnProps: {
    disabled: boolean;
    "data-testid"?: string;
  };
  sendRequestsBtnDisabledReason: string | null;
  onExcludedClick?: () => void;
}) {
  return (
    <div className="px-4 py-3 flex items-center">
      <div className="flex grow items-center space-x-2 text-sm">
        <div>Selected Materials: {data.selectedCount}</div> <div>|</div>
        <div>
          Request being sent for: {data.selectedCount - data.excludedCount}
        </div>{" "}
        <div>|</div>
        <div data-testid="excluded-container">
          Excluded:{" "}
          <Tooltip title="view excluded materials">
            <span
              className="danger-text underline cursor-pointer"
              onClick={onExcludedClick}
              role={onExcludedClick ? "button" : undefined}
              tabIndex={onExcludedClick ? 0 : undefined}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onExcludedClick?.();
                }
              }}
            >
              {data.excludedCount}
            </span>
          </Tooltip>
        </div>
      </div>
      <div className="space-x-2">
        <Button
          onClick={onCancel}
          disabled={submitting}
          data-testid="cancel-btn"
        >
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={onSend}
          loading={submitting}
          {...sendRequestsBtnProps}
          title={sendRequestsBtnDisabledReason ?? undefined}
          data-testid="send-requests-btn"
        >
          Send Request{" "}
          {!sendRequestsBtnProps.disabled
            ? `(${data.emailsToBeSentCount})`
            : ""}
        </Button>
      </div>
    </div>
  );
}

export default Footer;
